module.exports = __webpack_public_path__ + "kak_ne_lishitsya_kvartiry.9056390194b4f29646f0.jpg";